import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

export const TooltipBubble = styled.span`
  position: absolute;
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  background: #1a1a1a;
  color: #fff;
  font-family: inherit;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.4;
  white-space: nowrap;
  padding: 6px 12px;
  border-radius: 6px;
  pointer-events: none;
  z-index: 1500;
  animation: ${fadeIn} 0.15s ease;
  visibility: ${(props) => (props.$forceVisible ? 'visible' : 'hidden')};
  opacity: ${(props) => (props.$forceVisible ? 1 : 0)};
`;

export const Wrapper = styled.button`
  all: unset;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  position: relative;
  -webkit-tap-highlight-color: transparent;

  &:hover ${TooltipBubble} {
    visibility: visible;
    opacity: 1;
  }
`;
